export default __webpack_public_path__ + "static/banner-mobile-5ff3d9f461ab1053204ed9dfd7a23c51.svg";